export enum CurrencySymbolPosition {
    PREFIX = 'prefix',
    SUFFIX = 'suffix'
}

export interface ICurrencyConfigItem {
    symbol?: string;
    symbolPosition?: CurrencySymbolPosition;
    symbolSeparator?: string;
    decimalSeparator?: string;
    currencyHeaderLabel?: string;
}

export interface ICurrenciesConfig {
    [iso: string]: ICurrencyConfigItem;
}
